import React from "react";
import { checkCanEditPublish } from "src/utils/checkPublishPermission";
import Link from "src/components/link";

export default function ButtonEdit({ postItem = {} }) {
  let canEditPublishPost = true;

  // người không có chuyên mục xuất bản thì không được quyền edit bài đã xuất bản chuyên mục đó
  // không hiện nút 'Edit' trong trường hợp này
  if (postItem.posttype && postItem.posttype.type_code === "ready") {
    canEditPublishPost = checkCanEditPublish(postItem);
  }

  const condition = !postItem.editing_status && canEditPublishPost;

  if (!condition) {
    return <></>;
  }

  return (
    <Link to={`/posts/edit/${postItem._id}`}>
      <span className="btn btn-danger btn-sm mr-2">
        <i className="fas fa-pencil-alt"></i> Edit
      </span>
    </Link>
  );
}
